module.exports = __webpack_public_path__ + "static/media/DoughnutChart.bcf299a1.svg";